import axios from 'axios'

// THis is the solargraf intregration...

const apiUrl = `https://dev.iondeveloper.com/api/proposal/solargraf/?api_key=${process.env.REACT_APP_API_KEY}`

export const getTariffs = async (address, lat, long, setTariffs) => {
  try {
    const res = await axios.post(apiUrl, {
      method: 'get_tariffs',
      fullAddress: address,
      latitude: lat,
      longitude: long,
      zoning: 'residential'
    })

    if (res && res.data) {
      setTariffs(res.data.data.data)
      // console.log(res.data)
    }
  } catch (error) {
    console.error('Error fetching tariffs:', error)
  }
}


export const createProject = async (customer, usage, tariffId, setShowError, setErrorMessage) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // Utility to determine the correct year for each month
  const getBillingYear = (month) => {
    if (month < 11) return currentYear; // January to October use the current year
    return currentDate.getMonth() + 1 < 11 ? currentYear - 1 : currentYear;
  };

  try {
    const res = await axios.post(apiUrl, {
      method: 'create_project',
      projectName: `${customer.name} ${customer.street}`,
      address: `${customer.street}, ${customer.city}, ${customer.state} ${customer.zip}`,
      clientName: customer.name,
      clientPhone: customer.phone,
      clientEmail: customer.email,
      sfDesignId: customer.designId,
      mapProvider: 'nearmap',
      latitude: customer.latitude,
      longitude: customer.longitude,
      zoomLevel: 21,
      billAmount1: usage[0],
      billStart1: `${getBillingYear(1)}-01-01`,
      billEnd1: `${getBillingYear(1)}-01-31`,
      billType1: 'usage',
      billAmount2: usage[1],
      billStart2: `${getBillingYear(2)}-02-01`,
      billEnd2: `${getBillingYear(2)}-02-${getBillingYear(2) % 4 === 0 ? '29' : '28'}`, // Adjusts for leap year
      billType2: 'usage',
      billAmount3: usage[2],
      billStart3: `${getBillingYear(3)}-03-01`,
      billEnd3: `${getBillingYear(3)}-03-31`,
      billType3: 'usage',
      billAmount4: usage[3],
      billStart4: `${getBillingYear(4)}-04-01`,
      billEnd4: `${getBillingYear(4)}-04-30`,
      billType4: 'usage',
      billAmount5: usage[4],
      billStart5: `${getBillingYear(5)}-05-01`,
      billEnd5: `${getBillingYear(5)}-05-31`,
      billType5: 'usage',
      billAmount6: usage[5],
      billStart6: `${getBillingYear(6)}-06-01`,
      billEnd6: `${getBillingYear(6)}-06-30`,
      billType6: 'usage',
      billAmount7: usage[6],
      billStart7: `${getBillingYear(7)}-07-01`,
      billEnd7: `${getBillingYear(7)}-07-31`,
      billType7: 'usage',
      billAmount8: usage[7],
      billStart8: `${getBillingYear(8)}-08-01`,
      billEnd8: `${getBillingYear(8)}-08-31`,
      billType8: 'usage',
      billAmount9: usage[8],
      billStart9: `${getBillingYear(9)}-09-01`,
      billEnd9: `${getBillingYear(9)}-09-30`,
      billType9: 'usage',
      billAmount10: usage[9],
      billStart10: `${getBillingYear(10)}-10-01`,
      billEnd10: `${getBillingYear(10)}-10-31`,
      billType10: 'usage',
      billAmount11: usage[10],
      billStart11: `${getBillingYear(11)}-11-01`,
      billEnd11: `${getBillingYear(11)}-11-30`,
      billType11: 'usage',
      billAmount12: usage[11],
      billStart12: `${getBillingYear(12)}-12-01`,
      billEnd12: `${getBillingYear(12)}-12-31`,
      billType12: 'usage',
      genabilityTariffId: tariffId,
      projectType: 'residential',
      zoning: 'residential'
    });

    if (res.data.success === false) {
      const attributes = res.data.data?.error?.description?.data?.attributes;

      let errorDescription = "An error occurred while creating the project.";
      if (attributes && typeof attributes === 'object') {
        errorDescription = Object.entries(attributes)
          .map(([key, values]) => `${key}: ${Array.isArray(values) ? values.join(', ') : values}`)
          .join(' | ');
      }

      setShowError(true);
      setErrorMessage(`Error creating SolarGraf project. "${errorDescription}"`);
      setTimeout(() => {
        setShowError(false);
        setErrorMessage('');
      }, 10000)
      return {
        success: false,
        message: errorDescription
      };
    }

    // console.log(res.data);
    return res.data;

  } catch (error) {
    console.error("Error creating project:", error.message || error);
    setShowError(true);
    setErrorMessage(`Error creating project - ${error.message}`);
    setTimeout(() => {
      setShowError(false);
      setErrorMessage('');
    }, 7500);
    return {
      success: false,
      message: "There was an error creating the project. Please try again later.",
      error: error.response ? error.response.data : error.message
    };
  }
}

export const getProposalDetails = async (solarGrafProjectId, solarGrafDesignId) => {
  try {
    const res = await axios.post(apiUrl, {
      method: 'retrieve_proposal_info',
      projectId: solarGrafProjectId,
      proposalId: solarGrafDesignId
    });
    // console.log(res.data)
    return res.data
  } catch (error) {
    console.error('Error retrieving proposal details:', error);
    throw new Error('Failed to retrieve proposal details.');
  }
}

export const updateProject = async (projectId, projectName, clientName, clientPhone, clientEmail, repEmail) => {
  try {
    const res = await axios.post(apiUrl, {
      method: 'update_project',
      projectId: projectId,
      projectName: projectName,
      clientName: clientName,
      clientPhone: clientPhone,
      clientEmail: clientEmail,
      repEmail: repEmail

    });
    // console.log(res.data)
    return res.data
  } catch (error) {
    console.error('Error retrieving proposal details:', error);
    throw new Error('Failed to retrieve proposal details.');
  }
}

